import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ServiceConfig } from '../models/service-config.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceConfigService {
  private http = inject(HttpClient);

  getServiceConfig (pagerDutyServiceId: string): Observable<HttpResponse<ServiceConfig>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}`;
    return this.http.get<ServiceConfig>(endpoint, { observe: 'response', responseType: 'json' });
  }

  getServiceConfigs (): Observable<HttpResponse<ServiceConfig[]>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}`;
    return this.http.get<ServiceConfig[]>(endpoint, { observe: 'response', responseType: 'json' });
  }

  patchServiceConfig = (pagerDutyServiceId: string, serviceConfig: ServiceConfig): Observable<HttpResponse<ServiceConfig>> => {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}`;
    return this.http.patch<ServiceConfig>(endpoint, serviceConfig, { observe: 'response', responseType: 'json' });
  };
}
